import React, { useMemo } from 'react';
import { styled } from '@linaria/react';
import { ColorPath } from 'types/Theme';
import { ContentWrapper } from '@daedalus/atlas/helpers/ContentWrapper';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { cssTheme } from '@daedalus/atlas/themes';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { CardHeaderLayout, ThickBorderCard } from './RoomVariant';
import { translationMessages } from './translationMessages';
import { RoomCardVariants } from './types';
interface RoomDetailsVariantProps {
  variant: RoomCardVariants;
  children: React.ReactNode;
  offerCount: number;
}
const _exp = /*#__PURE__*/() => ThickBorderCard;
const RoomDetailsLayout = /*#__PURE__*/styled(_exp())({
  name: "RoomDetailsLayout",
  class: "r1xsllam",
  propsAsIs: true
});
const getTranslationKeysForVariants = (offerCount, isBestDeal) => {
  const [messageIdKey, pluralMessageKey] = isBestDeal ? ['bestAvailableDeal', 'bestAvailableDeals'] : ['ourBestDeal', 'ourBestDeals'];
  return offerCount > 1 ? {
    messageId: translationMessages[pluralMessageKey].id,
    defaultMessage: translationMessages[pluralMessageKey].defaultMessage
  } : {
    messageId: translationMessages[messageIdKey].id,
    defaultMessage: translationMessages[messageIdKey].defaultMessage
  };
};
export const RoomDetailsVariant = ({
  variant,
  offerCount,
  children
}: RoomDetailsVariantProps) => {
  const {
    colors
  } = cssTheme;
  const isBestDeal = variant === RoomCardVariants.BestDeal;
  const {
    messageId,
    defaultMessage
  } = getTranslationKeysForVariants(offerCount, isBestDeal);
  const {
    borderColor,
    bgColor,
    contentColor
  } = useMemo(() => {
    if (isBestDeal) {
      return {
        borderColor: 'border.success.c300',
        bgColor: colors.background.featured.c200,
        contentColor: colors.content.success.c900
      };
    }
    return {
      borderColor: 'border.brand.c300',
      bgColor: colors.background.brand.c100,
      contentColor: colors.content.brand.c800
    };
  }, [isBestDeal, colors]);
  return <RoomDetailsLayout borderRadius="lg" borderColorPath={borderColor as ColorPath}>
      <CardHeaderLayout bgColor={bgColor} contentColor={contentColor} iconSlot={<Icon name={isBestDeal ? 'Party' : 'ThumbsUp'} />} titleSlot={<Text variant="labelM">
            <FormattedMessageWrapper {...{
        id: messageId,
        defaultMessage
      }} />
          </Text>} />
      <ContentWrapper padding="s500">{children}</ContentWrapper>
    </RoomDetailsLayout>;
};

require("./RoomDetailsVariant.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomDetailsVariant.tsx");